import { createContext, useContext, useRef, useState, useCallback } from 'react';

// Presentation only. The route supplies an account- and history-entry-scoped memory.
export const DetailReturnContext = createContext(null);
export const useDetailReturn = () => useContext(DetailReturnContext);
export function useDetailViewState(key, initial) {
  const context = useDetailReturn();
  const entry = context?.entry;
  const [, render] = useState(0);
  const state = useRef(null);
  if (!state.current || state.current.entry !== entry || state.current.key !== key) {
    const saved = entry?.presentation?.[key];
    state.current = {
      entry,
      key,
      value: saved === undefined ? (typeof initial === 'function' ? initial() : initial) : saved,
    };
  }
  if (entry?.current() && entry.presentation?.[key] === undefined)
    (entry.presentation ||= {})[key] = state.current.value;
  const set = useCallback(
    (next) => {
      if (state.current.entry !== entry || state.current.key !== key || (entry && !entry.current()))
        return;
      const value = typeof next === 'function' ? next(state.current.value) : next;
      if (Object.is(value, state.current.value)) return;
      state.current.value = value;
      if (entry) (entry.presentation ||= {})[key] = value;
      render((v) => v + 1);
    },
    [entry, key],
  );
  return [state.current.value, set];
}
